import { jsx as _jsx } from "react/jsx-runtime";
export const CloseSearchButton = ({
  children,
  onClose
}) => {
  return /*#__PURE__*/_jsx("a", {
    href: "#",
    onClick: onClose,
    color: "icon-core-subtle",
    children: children
  });
};